import { IAppState } from '../../../AppModulesWrapper';

export function selectPreviousBets(state: IAppState): number[] {
  return state.servicePickerWidget.auction.previousBets;
}
